import React from "react";
import { Icon } from "../../../_components";

export function Calendars() {
  return (
    <div className="chronos-help-topic-page chronos-calendars-topic">
      <h3 className="chronos-topic-header">Calendar Basics</h3>
      <p>
        Calendars are used to divide and make sense of time. They can vary
        between cultures. In our world, people largely use the Gregorian
        calendar, but other calendars are used either officially (e.g. in Iran,
        parts of India) or to calculate holidays (Buddhist calendar, Chinese
        lunar calendar).
      </p>
      <p>
        In Chronicles, you can create your own calendar, customize the names and
        durations of time units (hours, months, years, etc.), and add leap days.
      </p>
      <h3 className="chronos-topic-header">
        Setting up and Editing your Calendar
      </h3>
      <p>
        During Chronicles set up, you can choose a template for your Calendar.
        There are several templates to choose from, including the Custom "empty"
        one you can build from scratch.
      </p>
      <p>
        To edit your Chronicle calendar, click the Calendar Manager icon in the
        right hand menu bar. <Icon icon="fal fa-calendar-edit fa-fw" /> There
        are two tabs - Months and Time. You must save changes to your calendar
        before closing the edit screen!
      </p>
      <h3 className="chronos-topic-header">Calendar Months Tab</h3>
      <p>
        When editing your calendar (<strong>Calendar Manager</strong>{" "}
        <Icon icon="fal fa-calendar-edit fa-fw" /> on the right), you can add,
        delete, and rename months. Under the Days column, you can specify how
        long each month is. For example, in the Gregorian calendar, February is
        28 days, but March is 31.
      </p>
      <p>
        <strong>Leap days</strong> are extra days added to the <em>end</em> of
        this month, while the <strong>Period</strong> states how often these are
        added. For example, February 29th is one Leap day. It occurs every 4
        years, and so the Period for February would be 4 (see image below). Leap
        days are always added to the end of their parent Month.
      </p>
      {/* Image UUID: f21329f7-d683-451a-ab31-19a58e349382 */}
      <img
        src="https://worldanvil-chronos.nyc3.digitaloceanspaces.com/default/images/chronos-february-month.png"
        alt="February with 28 days, 1 Leap days, and a Period of 4."
      />
      <p>
        Leap months are extra months that sometimes occur during your yearly
        cycle. The Gregorian calendar doesn't have leap months, but others do
        (Jewish Calendar). Some popular fantasy calandars also have multi-day
        celebrations inserted every 4 years.
      </p>
      <p>
        To create a Leap month, start by adding a Month with 0{" "}
        <strong>Days</strong>. Then set the duration of your leap month under{" "}
        <strong>Leap Days</strong>, and set the <strong>Period</strong> (how
        often this extra leap month occurs).
      </p>
      <h3 className="chronos-topic-header">Calendar Time Tab</h3>
      <p>
        When editing your calendar (<strong>Calendar Manager</strong>{" "}
        <Icon icon="fal fa-calendar-edit fa-fw" /> on the right), you can rename
        your time units (minutes, hours, days, etc.) and set how they relate to
        each other. In our world, there are 24 hours in a day - but maybe not in
        yours!
      </p>
      <p>
        If you rename time units, they will repopulate the form with the new
        name. In the image below, I renamed Days to "Sundowns".
      </p>
      {/* Image UUID: a10aac03-36d3-4aaa-a036-3d0126c422b3 */}
      <img
        src="https://worldanvil-chronos.nyc3.digitaloceanspaces.com/default/images/chronos-sundowns-days.png"
        alt="Days are called Sundowns, and there are 365 Sundowns in a Year."
      />
      <h3 className="chronos-topic-header">TrueTime</h3>
      <p>
        In Chronicles, time is tracked in a base unit of seconds, starting from
        zero. We call this TrueTime. Calendars transform TrueTime into a more
        user-friendly date &amp; time (and handle all the calculations!) so you
        shouldn't have to manage TrueTime directly.
      </p>
      <p>
        Since TrueTime uses seconds as the base unit, these cannot be re-named,
        and always have a duration of 1. However, your Minutes, Hours, etc, can
        have completely customized names and durations (see Calendars)
      </p>
    </div>
  );
}
